import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { ExtensionHandler } from '@cp/src/utils/extension.utils';
import isLitmusExperimentEnabled from '@cp/utils/isLitmusExperimentEnabled';
import logoutFromAmeyo from '@cp/utils/logoutFromAmeyo';
import { LITMUS_EXPERIMENT_NAMES } from '../constants/litmusExperimentNames';
import { logError } from '../utils/ApiHelper';
import { Roles } from '../pages/auth/constants/AuthConstants';

export const useAmeyoIntegration = () => {
  const [isAmeyoNewIntegrationEnabled, setIsAmeyoNewIntegrationEnabled] = useState(false);
  const [isHRCNewIntegration, setIsHRCNewIntegration] = useState(false);

  const roles = useSelector((store: RootState) => store?.common?.userData?.roles);
  const isDc97User =
    (roles?.includes(Roles.ROLE_HUMAN_REMINDER_AGENT) ||
      roles?.includes(Roles.ROLE_HUMAN_REMINDER_SPADE_CALLING_AGENT)) &&
    !roles.includes(Roles.ROLE_HUMAN_REMINDER_CHAT_AGENT);
  const referenceId = useSelector((state: RootState) => state?.common?.userData?.referenceId);
  const agentId = useSelector((state: RootState) => state?.common?.userData?.referenceId);

  useEffect(() => {
    if (isDc97User) {
      isLitmusExperimentEnabled(LITMUS_EXPERIMENT_NAMES.HRC_AMEYO_V3, {
        'x-customer-id': agentId
      })
        .then(res => {
          setIsHRCNewIntegration(res?.result);
        })
        .catch(err => {
          logError(err);
        });

      return;
    }
    isLitmusExperimentEnabled(LITMUS_EXPERIMENT_NAMES.COLLECTION_AMEYO_TELE_V3, {
      'x-customer-id': referenceId
    })
      .then(res => {
        if (res?.result) {
          ExtensionHandler.disableExtensionToggle(true);
          logoutFromAmeyo();
          ExtensionHandler.disableAmeyo();
          setIsAmeyoNewIntegrationEnabled(res?.result);
        } else {
          ExtensionHandler.disableExtensionToggle(false);
          ExtensionHandler.enableAmeyo();
        }
      })
      .catch(err => {
        ExtensionHandler.disableExtensionToggle(false);
        ExtensionHandler.enableAmeyo();
      });
  }, [isDc97User, agentId, referenceId]);

  return { isAmeyoNewIntegrationEnabled, isHRCNewIntegration };
};
